import { Stack, Text } from "@fluentui/react"
import React from "react"

import { L10n } from "@encoway/l10n"

import { useAppSelector } from "../../app/hooks"
import { selectSavedConfigurationCode } from "../../app/visualizationSlice"
import { TranslationConstants } from "../../constants/translationConstants"
import { getTheme } from "../../theme"

export default function SavedConfigurationCodeDisplay() {
    const configurationCode = useAppSelector(selectSavedConfigurationCode)

    if (!configurationCode) {
        return <></>
    }

    const theme = getTheme()
    return (
        <Stack
            horizontalAlign="center"
            verticalAlign="center"
            style={{
                backgroundColor: theme.palette.themePrimary,
                borderRadius: "2px",
                width: "10rem"
            }}
        >
            <Text
                variant="medium"
                style={{
                    fontSize: "1rem",
                    color: theme.palette.white,
                    fontWeight: 600
                }}
            >
                {L10n.format(TranslationConstants.Toolbar.DISPLAY_CODE, {
                    configurationCode
                })}
            </Text>
        </Stack>
    )
}
